/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FetchAllGatewayMerchantDataRequest} from '@cash-web/protos/squareup/roster/gateway.pb'
import {FetchAllGatewayMerchantDataResponse} from '@cash-web/protos/squareup/roster/gateway.pb'


export const fetchAll = (request: FetchAllGatewayMerchantDataRequest, options?: CashRequestOptions) => post<FetchAllGatewayMerchantDataRequest, FetchAllGatewayMerchantDataResponse>("/2.0/cash/fetch-all", request, {...options, rejectOnError: true })